import CampaignPrizePanel from './campaignPrizePanel.container';

export default CampaignPrizePanel;